<template>
  <panel-main-template>
    <template v-slot:page-title>Мои услуги</template>
    <template v-slot:page-info>
      Внимание! Максимальное количество создаваемых услуг -
      {{ limits.services_limit }}. Максимальное кол-во категорий -
      {{ limits.categories_limit }}</template
    >
    <template v-slot:page-content>
      <div class="service--container">
        <div class="text-center">
          <ul class="tabs-container shadow-card">
            <li
                @click="clickTab(item)"
                v-bind:class="{ active: item.isActive }"
                v-for="item in tabs"
                :key="item.id"
            >
              {{ item.name }}
            </li>
          </ul>
        </div>
        <div class="services-shadow shadow-card mrg-t-25">
            <div v-show="activeTabIndex == 1" class="services_tab">
              <div class="text-bold">Мои услуги</div>
              <div v-if="checkPermission('create_services')" class="actions">
                <div @click="showNewCategoryPopup" class="btn btn-sm btn-success mrg-t-10">
                  <f-awesome icon="plus"></f-awesome>
                  Добавить категорию
                </div>
                <div @click="showNewSubcatPopup" class="btn btn-sm btn-success mrg-t-10">
                  <f-awesome icon="plus"></f-awesome>
                  Добавить подкатегорию
                </div>
                <div @click="showNewServicePopup" class="btn btn-sm btn-success mrg-t-10">
                  <f-awesome icon="plus"></f-awesome>
                  Добавить услугу
                </div>
              </div>
              <div class="services-container mrg-t-15">
                <div v-if="!serviceList.length" class="text-orange text-center">
                  Услуги отсутствуют
                </div>
                <div class="descr">
                  <div>
                    <span class="circle"></span> - Категории, Подкатегории
                  </div>
                  <div>
                    <span class="circle"></span> - Услуги
                  </div>
                </div>
                <div class="search mrg-t-15">
                  <div class="field">
                    <div class="input-block">
                      <input
                          type="text"
                          v-model="searchService"
                          placeholder="Поиск по названию услуги"
                      />
                    </div>
                  </div>
                  <div class="reset">
                    <div @click="resetSearch" class="btn btn-sm btn-outline-danger">
                      <f-awesome icon="times"></f-awesome>
                    </div>
                  </div>
                </div>
                <div v-if="serviceList.length > 0" class="service--list-category">
                  <div
                      class="service--list-category-item shadow-card mrg-t-20"
                      v-for="item in computedData"
                      :key="item.id"
                  >
                    <!-- Категория -->
                    <div class="category">
                      <div
                          @click="moveUpCategory(item.id)"
                          class="move-btn text-center"
                      >
                        <div class="icon"><f-awesome icon="arrow-up"></f-awesome></div>
                        <div class="text">вверх</div>
                      </div>
                      <div v-show="!item.editCategory" class="service--list-cat-name">
                        {{ item.name }}
                      </div>
                      <div class="actions">
                        <div @click="showEditCategoryPopup(item)" class="btn btn-sm btn-outline-info">Изменить</div>
                        <div @click="deleteCategory(item.id)" class="btn btn-sm btn-danger">Удалить</div>
                      </div>
                    </div>
                    <!-- Услуги -->
                    <div class="services" v-if="item.services.length > 0">
                      <div
                          class="services-for"
                          v-for="service in item.services"
                          :key="service.id"
                      >
                        <div class="service" :class="{'subcategory': service.subcategory == 1}">
                          <div
                              @click="moveUpService(service.id)"
                              class="move-btn text-center"
                          >
                            <div class="icon"><f-awesome icon="arrow-up"></f-awesome></div>
                            <div class="text">вверх</div>
                          </div>
                          <div class="service--list-serv-name">
                            <div class="name">
                          <span v-if="service.hide == 1">
                            (<f-awesome icon="eye-slash"></f-awesome> скрыта)
                          </span>
                              {{ service.name }}
                            </div>
                            <div v-if="service.subcategory == 0" class="info">
                              <div class="price">
                                Стоимость: {{service.price}}
                              </div>
                              <div class="duration">
                                Продолжительность: {{service.time_hour}} ч. {{service.time_minute}} мин.
                              </div>
                            </div>
                          </div>
                          <div class="actions">
                            <div
                                v-if="service.subcategory == 1"
                                @click="showEditSubcategoryPopup(service)"
                                class="btn btn-sm btn-outline-info"
                            >
                              Изменить
                            </div>
                            <div
                                v-if="service.subcategory == 0"
                                @click="showEditServicePopup(service)"
                                class="btn btn-sm btn-outline-info"
                            >
                              Изменить
                            </div>
                            <div
                                v-if="service.subcategory == 0"
                                @click="deleteService(service.id)"
                                class="btn btn-sm btn-danger"
                            >
                              Удалить
                            </div>
                            <div
                                v-if="service.subcategory == 1"
                                @click="deleteSubcategory(service.id)"
                                class="btn btn-sm btn-danger"
                            >
                              Удалить
                            </div>
                          </div>
                        </div>
                        <!-- Модификации -->
                        <div class="modifications" v-if="service.modification.length > 0">
                          <div
                              class="modification"
                              v-for="modif in service.modification"
                              :key="modif.id"
                          >
                            <div
                                @click="moveUpModification(modif.id)"
                                class="move-btn text-center"
                            >
                              <div class="icon"><f-awesome icon="arrow-up"></f-awesome></div>
                              <div class="text">вверх</div>
                            </div>
                            <div class="service--list-modif-name">
                              <div class="name">
                            <span v-if="modif.hide == 1">
                              (<f-awesome icon="eye-slash"></f-awesome> скрыта)
                            </span>
                                {{ modif.name }}
                              </div>
                              <div class="info">
                                <div class="price">
                                  Стоимость: {{modif.price}}
                                </div>
                                <div class="duration">
                                  Продолжительность: {{modif.time_hour}} ч. {{modif.time_minute}} мин.
                                </div>
                              </div>
                            </div>
                            <div class="actions">
                              <div @click="showEditModifPopup(modif)" class="btn btn-sm btn-outline-info">Изменить</div>
                              <div @click="deleteModification(modif.id)" class="btn btn-sm btn-danger">Удалить</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-show="activeTabIndex == 2" class="resource_tab">
              <div class="text-bold">Ресурсы</div>
              <div class="hint">
                Рассмотрим на примере для чего нужны ресурсы: вы создаете ресурс,
                например "Массажный стол", кол-во штук, далее присваиваете ресурсу услуги
                для которых требуется данный ресурс.
                Если есть 1 массажный стол и 2 сотрудника, которые делают массаж,
                то клиент сможет записаться на данную услугу в одно время только к одному из
                сотрудников, у второго доступное время будет пропадать на данную услугу в данное время.
              </div>
              <div class="services-container mrg-t-15">
                <resources :services-list="serviceList"></resources>
              </div>
            </div>

        </div>
      </div>

      <popup
          :closeButton="newCategoryPopup.closeButton"
          :actionButton="newCategoryPopup.actionButton"
          :actionClass="newCategoryPopup.actionClass"
          :show="newCategoryPopup.show"
          @closePopup="closeNewCategoryPopup"
          @actionPopup="addCategory"
      >
        <div slot="header">Создание категории услуг</div>
        <div slot="body">
          <form class="mrg-t-15">
            <div class="input-block">
              <label for="new_category">Категория <span class="req">*</span></label>
              <input
                  type="text"
                  @focus="formError.category = ''"
                  @blur="vCategory"
                  v-model="category"
                  id="new_category"
              />
              <div class="hint">Имя категории оказываемых услуг</div>
              <div class="form-error">{{ formError.category }}</div>
            </div>
          </form>
        </div>
      </popup>

      <popup
          :closeButton="newSubcatPopup.closeButton"
          :actionButton="newSubcatPopup.actionButton"
          :actionClass="newSubcatPopup.actionClass"
          :show="newSubcatPopup.show"
          @closePopup="closeNewSubcatPopup"
          @actionPopup="addSubcategory"
      >
        <div slot="header">
          <div>Создание подкатегории услуг</div>
          <div class="text-hint">
            Пользоваться подкатегориями необязательно. Услуги можно добавлять сразу в категории. Чаще всего, подкатегории нужны,
            если у услуги есть модификации.
            Например: есть категория "Ногтевой сервис" и вместо того, чтобы свалить в кучу все услуги, связанные с ногтевым
            сервисом, вы можете создать подкатегорию "Уход" и уже в данную подкатегорию добавить "Парафинотерапия", "SPA-уход для рук".
            Далее добавить подкатегорию "Маникюр" и уже туда добавить разные виды маникюра
            и т.д. Таким образом, клиентам будет легче ориентироваться
          </div>
        </div>
        <div slot="body">
          <form class="mrg-t-15">
            <div class="input-block">
              <label for="category_list_for_sub">Категория <span class="req">*</span></label>
              <select
                  @focus="formError.subcategory.category_id = ''"
                  @blur="vServiceSubcatCat"
                  v-model="newSubcategory.category_id"
                  id="category_list_for_sub"
                  name="category_list_for_sub"
              >
                <option
                    v-for="item in serviceList"
                    :key="item.id"
                    :value="item.id"
                >{{ item.name }}</option
                >
              </select>
              <div class="form-error">{{ formError.subcategory.category_id }}</div>
            </div>
            <div class="input-block">
              <label for="new_service_name"
              >Название подкатегории <span class="req">*</span></label
              >
              <input
                  @focus="formError.subcategory.name = ''"
                  @blur="vSubcatName"
                  type="text"
                  v-model="newSubcategory.name"
                  id="new_subcategory_name"
              />
              <div class="form-error">{{ formError.subcategory.name }}</div>
            </div>
          </form>
        </div>
      </popup>

      <popup
          :closeButton="newServicePopup.closeButton"
          :actionButton="newServicePopup.actionButton"
          :actionClass="newServicePopup.actionClass"
          :show="newServicePopup.show"
          @closePopup="closeNewServicePopup"
          @actionPopup="addService"
      >
        <div slot="header">
          <div>Создание услуги</div>
          <div class="text-hint">
            Не забудьте присвоить новую услугу одному из сотрудников, иначе
            она не будет отображаться на странице записи онлайн ! <br>
            Для этого перейдите в раздел "Сотрудники", кликните "Изменить" на нужном сотруднике и прокликайте актуальный
            список оказываемых услуг
          </div>
        </div>
        <div slot="body">
          <form class="mrg-t-15">
            <div class="input-block">
              <label for="category_list"
              >Категория <span class="req">*</span></label
              >
              <select
                  @focus="formError.service.category_id = ''"
                  @blur="vServiceCat"
                  @change="newService.service_id = ''"
                  v-model="newService.category_id"
                  id="category_list"
                  name="category_list"
              >
                <option
                    v-for="item in serviceList"
                    :key="item.id"
                    :value="item.id"
                >{{ item.name }}</option
                >
              </select>
              <div class="form-error">{{ formError.service.category_id }}</div>
            </div>
            <div class="input-block">
              <label for="category_list">Подкатегория</label>
              <select
                  @focus="formError.service.service_id = ''"
                  v-model="newService.service_id"
                  id="subcategory_list"
                  name="subcategory_list"
              >
                <option
                    value=""
                ></option>
                <option
                    v-for="item in subcatList"
                    :key="item.id"
                    :value="item.id"
                >{{ item.name }}</option>
              </select>
              <div class="hint">
                !!! Выбирайте значение, если услугу необходимо добавить в подкатегорию (это необязательно, можно оставить пустым, тем самым добавив
                услугу сразу в категорию)
              </div>
              <div class="form-error">{{ formError.service.service_id }}</div>
            </div>
            <div class="input-block">
              <label for="new_service_name">
                Название услуги <span class="req">*</span>
              </label>
              <input
                  @focus="formError.service.name = ''"
                  @blur="vServiceName"
                  type="text"
                  v-model="newService.name"
                  id="new_service_name"
              />
              <div class="form-error">{{ formError.service.name }}</div>
            </div>
            <div class="input-block">
              <label for="new_service_price"
              >Стоимость услуги <span class="req">*</span></label
              >
              <input
                  @focus="formError.service.price = ''"
                  @blur="vServicePrice"
                  type="text"
                  v-model="newService.price"
                  id="new_service_price"
              />
              <div class="hint">
                Если услуга бесплатная, то можно поставить 0. Тогда цена не будет отображаться
                на странице записи
              </div>
              <div class="form-error">{{ formError.service.price }}</div>
            </div>
            <div class="input-block">
              <label>Время выполнения услуги <span class="req">*</span></label>
              <div class="service--service-time-inputs">
                <div>
                  <select v-model="newService.time_hour">
                    <option
                        v-for="(hour, index) in hourArray"
                        :key="index"
                        :value="hour"
                    >{{ hour }}</option
                    >
                  </select>
                  <div class="hint">Часов</div>
                </div>
                <div>
                  <select v-model="newService.time_minute">
                    <option
                        v-for="(minute, index) in minuteArray"
                        :key="index"
                        :value="minute"
                    >{{ minute }}</option
                    >
                  </select>
                  <div class="hint">Минут</div>
                </div>
              </div>
            </div>
            <div class="input-block">
              <label for="description">Описание услуги</label>
              <textarea
                  type="text"
                  rows="6"
                  v-model="newService.description"
                  @blur="vServiceDescription"
                  id="description"
              ></textarea>
              <div class="form-error">{{ formError.service.description }}</div>
            </div>
            <div class="input-block">
              <label>
                <input type="checkbox" v-model="newService.hide">
                Скрыть услугу на странице записи
              </label>
              <div class="hint">
                При выборе данного пункта, услуга не будет отображаться на странице записи онлайн,
                но в разделе "Журнал записей" вы сможете с ней работать
              </div>
            </div>
            <div class="input-block">
              <label>
                <input type="checkbox" v-model="newService.price_from_flag">
                Отображать стоимость данной услуги со словом "От"
              </label>
              <div class="hint">
                При выборе данного пункта, стоимость услуги будет отображаться на странице записи онлайн
                со словом "От". Например: "От 1000 Руб."
              </div>
            </div>
            <div class="input-block">
              <label>
                <input type="checkbox" v-model="newService.is_group">
                Групповая услуга
              </label>
              <div class="hint">
                При выборе данного пункта, услуга станет "Групповой".
                Для того, чтобы клиенты смогли записываться на групповые услуги, вам
                необходимо создавать групповые записи через раздел
                Журнал Записей самостоятельно, либо установить планировщик через
                раздел "Расписание".
              </div>
            </div>
          </form>
        </div>
      </popup>

      <popup
        :closeButton="deleteServicePopup.closeButton"
        :actionButton="deleteServicePopup.actionButton"
        :actionClass="deleteServicePopup.actionClass"
        :show="deleteServicePopup.show"
        @closePopup="closeDeleteServicePopup"
        @actionPopup="deleteServiceSubmit"
      >
        <div slot="header">Подтвердить удаление?</div>
        <div slot="body">
          Услуга будет удалена без возможности восстановления. Уже имеющиеся
          записи на данную услугу не пострадают.
        </div>
      </popup>

      <popup
          :closeButton="deleteModificationPopup.closeButton"
          :actionButton="deleteModificationPopup.actionButton"
          :actionClass="deleteModificationPopup.actionClass"
          :show="deleteModificationPopup.show"
          @closePopup="closeDeleteModificationPopup"
          @actionPopup="deleteModificationSubmit"
      >
        <div slot="header">Подтвердить удаление?</div>
        <div slot="body">
          Услуга будет удалена без возможности восстановления. Уже имеющиеся
          записи на данную услугу не пострадают.
        </div>
      </popup>

      <popup
        :closeButton="deleteSubcategoryPopup.closeButton"
        :actionButton="deleteSubcategoryPopup.actionButton"
        :actionClass="deleteSubcategoryPopup.actionClass"
        :show="deleteSubcategoryPopup.show"
        @closePopup="closeDeleteSubcategoryPopup"
        @actionPopup="deleteServiceSubmit"
      >
        <div slot="header">Подтвердить удаление?</div>
        <div slot="body">
          <span style="color: #F87979; font-weight: 500">ВНИМАНИЕ!</span> Будет
          удалена подкатегория и все сопутствующие услуги. Если данная подкатегория
          присвоена какому-либо сотруднику, то после удаления она станет
          недоступна. Уже имеющиеся записи на одну из
          данных услуг не пострадают.
        </div>
      </popup>

      <popup
        :closeButton="deleteCategoryPopup.closeButton"
        :actionButton="deleteCategoryPopup.actionButton"
        :actionClass="deleteCategoryPopup.actionClass"
        :show="deleteCategoryPopup.show"
        @closePopup="closeDeleteCategoryPopup"
        @actionPopup="deleteCategorySubmit"
      >
        <div slot="header">Подтвердить удаление?</div>
        <div slot="body">
          <span style="color: #F87979; font-weight: 500">ВНИМАНИЕ!</span> Будет
          удалена категория и все сопутствующие услуги. Если данная категория
          присвоена какому-либо сотруднику, то после удаления она станет
          недоступна (запись онлайн может стать недоступной, если у сотрудника
          не останется присвоенных категорий). Уже имеющиеся записи на одну из
          данных услуг не пострадают.
        </div>
      </popup>

      <!-- Редактирование категории -->
      <popup
          :closeButton="editCategoryPopup.closeButton"
          :actionButton="editCategoryPopup.actionButton"
          :actionClass="editCategoryPopup.actionClass"
          :show="editCategoryPopup.show"
          @closePopup="closeEditCategoryPopup"
          @actionPopup="editCatName"
      >
        <div slot="header">Изменение категории услуг</div>
        <div slot="body">
          <form class="mrg-t-15">
            <div class="input-block">
              <label for="edit_category">Категория <span class="req">*</span></label>
              <input
                  type="text"
                  v-model="editCatItem.name"
                  id="edit_category"
              />
              <div class="hint">Имя категории оказываемых услуг</div>
            </div>
          </form>
        </div>
      </popup>

      <!-- Редактирование подкатегории -->
      <popup
          :closeButton="editSubcategoryPopup.closeButton"
          :actionButton="editSubcategoryPopup.actionButton"
          :actionClass="editSubcategoryPopup.actionClass"
          :show="editSubcategoryPopup.show"
          @closePopup="closeEditSubcategoryPopup"
          @actionPopup="editService"
      >
        <div slot="header">Изменение подкатегории услуг</div>
        <div slot="body">
          <form class="mrg-t-15">
            <div class="input-block">
              <label for="edit_subcategory">Название подкатегории <span class="req">*</span></label>
              <input
                  type="text"
                  v-model="editServiceItem.name"
                  id="edit_subcategory"
              />
              <div class="hint">Имя подкатегории оказываемых услуг</div>
            </div>
          </form>
        </div>
      </popup>


      <!-- Редактирование услуги -->
      <popup
          :closeButton="editServicePopup.closeButton"
          :actionButton="editServicePopup.actionButton"
          :actionClass="editServicePopup.actionClass"
          :show="editServicePopup.show"
          @closePopup="closeEditServicePopup"
          @actionPopup="editService"
      >
        <div slot="header">Изменение услуги</div>
        <div slot="body">
          <form>
            <div class="input-block">
              <label v-bind:for="'edit_name_' + editServiceItem.id">Название услуги</label>
              <input
                  type="text"
                  @focus="formError.editService.name = ''"
                  @blur="vEditServiceName"
                  v-model="editServiceItem.name"
                  v-bind:id="'edit_name_' + editServiceItem.id"
                  required
              />
              <div class="form-error">{{ formError.editService.name }}</div>
              <div class="hint">
                <span class="text-danger">Внимание!</span> Пожалуйста, не меняйте название по смыслу.
                Например, нельзя менять услугу "Стрижка" на "Укладка", для этого создайте новую услугу, но можно
                изменить услугу "Стрижка мужская" на "Стрижка мужская короткие волосы"
              </div>
            </div>
            <div class="input-block">
              <label v-bind:for="'edit_price_' + editServiceItem.id">Стоимость услуги</label>
              <input
                type="text"
                @focus="formError.editService.price = ''"
                @blur="vEditServicePrice"
                v-model="editServiceItem.price"
                v-bind:id="'edit_price_' + editServiceItem.id"
                required
              />
              <div class="form-error">{{ formError.editService.price }}</div>
              <div class="hint">
                Если услуга бесплатная, то можно поставить 0. Тогда цена не будет отображаться
                на странице записи
              </div>
            </div>
            <div class="input-block">
              <label>Время выполнения услуги</label>
              <div class="service--service-time-inputs">
                <div>
                  <select v-model="editServiceItem.time_hour">
                    <option
                      v-for="(hour, index) in hourArray"
                      :key="index"
                      :value="hour"
                      >{{ hour }}</option
                    >
                  </select>
                  <div class="hint">Часов</div>
                </div>
                <div>
                  <select v-model="editServiceItem.time_minute">
                    <option
                      v-for="(minute, index) in minuteArray"
                      :key="index"
                      :value="minute"
                      >{{ minute }}</option
                    >
                  </select>
                  <div class="hint">Минут</div>
                </div>
              </div>
            </div>
            <div class="input-block">
              <label v-bind:for="'edit_description_' + editServiceItem.id">Описание услуги</label>
              <textarea
                type="text"
                rows="6"
                @blur="vEditServiceDescription"
                v-model="editServiceItem.description"
                v-bind:id="'edit_description_' + editServiceItem.id"
              ></textarea>
              <div class="form-error">{{ formError.editService.description }}</div>
              <div class="hint">Ограничение: 595 символов</div>
            </div>
            <div class="input-block">
              <label>
                <input type="checkbox" v-model="editServiceItem.hide">
                Скрыть услугу на странице записи
              </label>
              <div class="hint">
                При выборе данного пункта, услуга не будет отображаться на странице записи онлайн,
                но в разделе "Журнал записей" вы сможете с ней работать
              </div>
            </div>
            <div class="input-block">
              <label>
                <input type="checkbox" v-model="editServiceItem.price_from_flag">
                Отображать стоимость данной услуги со словом "От"
              </label>
              <div class="hint">
                При выборе данного пункта, стоимость услуги будет отображаться на странице записи онлайн
                со словом "От". Например: "От 1000 Руб."
              </div>
            </div>
            <div class="input-block">
              <label>
                <input type="checkbox" v-model="editServiceItem.is_group">
                Групповая услуга
              </label>
              <div class="hint">
                При выборе данного пункта, услуга станет "Групповой".
                Для того, чтобы клиенты смогли записываться на групповые услуги, вам
                необходимо создавать групповые записи через раздел
                Журнал Записей самостоятельно, либо установить планировщик через
                раздел "Расписание".
              </div>
            </div>
          </form>
        </div>
      </popup>


      <!-- Редактирование модификации -->
      <popup
          :closeButton="editModifPopup.closeButton"
          :actionButton="editModifPopup.actionButton"
          :actionClass="editModifPopup.actionClass"
          :show="editModifPopup.show"
          @closePopup="closeEditModifPopup"
          @actionPopup="editModification"
      >
        <div slot="header">Изменение услуги</div>
        <div slot="body">
          <form>
            <div class="input-block">
              <label v-bind:for="'edit_name_' + editServiceItem.id">Название услуги</label>
              <input
                  type="text"
                  @focus="formError.editService.name = ''"
                  @blur="vEditServiceName"
                  v-model="editServiceItem.name"
                  v-bind:id="'edit_name_' + editServiceItem.id"
                  required
              />
              <div class="form-error">{{ formError.editService.name }}</div>
              <div class="hint">
                <span class="text-danger">Внимание!</span> Пожалуйста, не меняйте название по смыслу.
                Например, нельзя менять услугу "Стрижка" на "Укладка", для этого создайте новую услугу, но можно
                изменить услугу "Стрижка мужская" на "Стрижка мужская короткие волосы"
              </div>
            </div>
            <div class="input-block">
              <label v-bind:for="'edit_price_' + editServiceItem.id">Стоимость услуги</label>
              <input
                type="text"
                @focus="formError.editService.price = ''"
                @blur="vEditServicePrice"
                v-model="editServiceItem.price"
                v-bind:id="'edit_price_' + editServiceItem.id"
                required
              />
              <div class="form-error">{{ formError.editService.price }}</div>
              <div class="hint">
                Если услуга бесплатная, то можно поставить 0. Тогда цена не будет отображаться
                на странице записи
              </div>
            </div>
            <div class="input-block">
              <label>Время выполнения услуги</label>
              <div class="service--service-time-inputs">
                <div>
                  <select v-model="editServiceItem.time_hour">
                    <option
                      v-for="(hour, index) in hourArray"
                      :key="index"
                      :value="hour"
                      >{{ hour }}</option
                    >
                  </select>
                  <div class="hint">Часов</div>
                </div>
                <div>
                  <select v-model="editServiceItem.time_minute">
                    <option
                      v-for="(minute, index) in minuteArray"
                      :key="index"
                      :value="minute"
                      >{{ minute }}</option
                    >
                  </select>
                  <div class="hint">Минут</div>
                </div>
              </div>
            </div>
            <div class="input-block">
              <label v-bind:for="'edit_description_' + editServiceItem.id">Описание услуги</label>
              <textarea
                type="text"
                rows="6"
                @blur="vEditServiceDescription"
                v-model="editServiceItem.description"
                v-bind:id="'edit_description_' + editServiceItem.id"
              ></textarea>
              <div class="form-error">{{ formError.editService.description }}</div>
              <div class="hint">Ограничение: 595 символов</div>
            </div>
            <div class="input-block">
              <label>
                <input type="checkbox" v-model="editServiceItem.hide">
                Скрыть услугу на странице записи
              </label>
              <div class="hint">
                При выборе данного пункта, услуга не будет отображаться на странице записи онлайн,
                но в разделе "Журнал записей" вы сможете с ней работать
              </div>
            </div>
            <div class="input-block">
              <label>
                <input type="checkbox" v-model="editServiceItem.price_from_flag">
                Отображать стоимость данной услуги со словом "От"
              </label>
              <div class="hint">
                При выборе данного пункта, стоимость услуги будет отображаться на странице записи онлайн
                со словом "От". Например: "От 1000 Руб."
              </div>
            </div>
            <div class="input-block">
              <label>
                <input type="checkbox" v-model="editServiceItem.is_group">
                Групповая услуга
              </label>
              <div class="hint">
                При выборе данного пункта, услуга станет "Групповой".
                Для того, чтобы клиенты смогли записываться на групповые услуги, вам
                необходимо создавать групповые записи через раздел
                Журнал Записей самостоятельно, либо установить планировщик через
                раздел "Расписание".
              </div>
            </div>
          </form>
        </div>
      </popup>


    </template>
  </panel-main-template>
</template>

<script>
// @ is an alias to /src
import PanelMainTemplate from "../../components/panel/MainTemplate";
import Popup from "../../components/Popup";
import Validator from "../../components/libraries/Validator";
import permissionMixin from "@/components/mixins/Permissions";
import CopyArrayAndObject from "../../components/libraries/CopyArrayAndObject";
import Resources from "../../components/panel/services/Resources.vue";
import servicesRepository from "../../repositories/services";

const copyArr = new CopyArrayAndObject();
const validator = new Validator();

export default {
  name: "Services",
  components: {
    Resources,
    Popup,
    PanelMainTemplate,
},
  mixins: [permissionMixin],
  data() {
    return {
      hourArray: [
        0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18,
        19, 20, 21, 22, 23
      ],
      minuteArray: [0, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55],
      category: "",
      newService: {
        category_id: "",
        service_id: "",
        name: "",
        price: "",
        time_hour: 0,
        time_minute: 0,
        description: "",
        hide: 0,
        price_from_flag: 0,
        is_group: 0
      },
      newSubcategory: {
        category_id: "",
        name: "",
      },
      formError: {
        category: "",
        service: {
          category_id: "",
          name: "",
          price: "",
          description: "",
          time_hour: "",
          time_minute: "",
          subcategory: "",
          price_from_flag: 0
        },
        editService: {
          name: "",
          price: "",
          description: ""
        },
        subcategory: {
          category_id: "",
          name: ""
        }
      },
      serviceList: [],
      newCategoryPopup: {
        show: false,
        closeButton: "Отмена",
        actionButton: "Создать",
        actionClass: "btn-success"
      },
      newSubcatPopup: {
        show: false,
        closeButton: "Отмена",
        actionButton: "Создать",
        actionClass: "btn-success"
      },
      newServicePopup: {
        show: false,
        closeButton: "Отмена",
        actionButton: "Создать",
        actionClass: "btn-success"
      },
      deleteServicePopup: {
        show: false,
        closeButton: "Отмена",
        actionButton: "Подтвердить",
        actionClass: "btn-success"
      },
      deleteModificationPopup: {
        show: false,
        closeButton: "Отмена",
        actionButton: "Подтвердить",
        actionClass: "btn-success"
      },
      deleteCategoryPopup: {
        show: false,
        closeButton: "Отмена",
        actionButton: "Подтвердить",
        actionClass: "btn-success"
      },
      deleteSubcategoryPopup: {
        show: false,
        closeButton: "Отмена",
        actionButton: "Подтвердить",
        actionClass: "btn-success"
      },
      editCategoryPopup: {
        show: false,
        closeButton: "Отмена",
        actionButton: "Сохранить",
        actionClass: "btn-success"
      },
      editCatItem: {id: '', name: ''},
      editSubcategoryPopup: {
        show: false,
        closeButton: "Отмена",
        actionButton: "Сохранить",
        actionClass: "btn-success"
      },
      editServicePopup: {
        show: false,
        closeButton: "Отмена",
        actionButton: "Сохранить",
        actionClass: "btn-success"
      },
      editModifPopup: {
        show: false,
        closeButton: "Отмена",
        actionButton: "Сохранить",
        actionClass: "btn-success"
      },
      editServiceItem: {
        id: '', name: '', price: 0, time_hour: 0,
        time_minute: 0, description: 0, hide: 0,
        price_from_flag: 0, is_group: 0
      },
      serviceDeleteId: "",
      modificationDeletedId: "",
      categoryDeleteId: "",
      searchService: '',
      limits: {
        categories_limit: "",
        services_limit: ""
      },
      tabs: [
        {
          id: 1,
          name: "Услуги",
          isActive: true
        },
        {
          id: 2,
          name: "Ресурсы",
          isActive: false
        },
      ],
    };
  },
  metaInfo: {
    title: "Мои Услуги - Enroller",
    meta: [
      {
        name: 'viewport',
        content: "width=device-width, initial-scale=1, minimum-scale=1, user-scalable=no"
      }
    ]
  },
  computed: {
    computedData(){
      let result = [];
      if(this.searchService.trim() === ''){
        result = this.serviceList;
      }else{
        let regexp = new RegExp(`${this.searchService.trim()}`, 'i');
        let list = copyArr.copy(this.serviceList);

        for(let key in list){
          let services = [];
          for(let service in list[key].services){
            let modifications = [];
            if(list[key].services[service].modification.length > 0){
              for(let modif in list[key].services[service].modification){
                if(regexp.test('' +list[key].services[service].modification[modif].name +'')){
                  // Первым делом вставляем модификацию
                  modifications[modifications.length] = list[key].services[service].modification[modif];
                }
              }
            }
            // Если есть модификации или услуга подходит под поиск, то вставляем
            if(
              regexp.test('' +list[key].services[service].name +'') ||
              modifications.length > 0
            ){
              services[services.length] = list[key].services[service];
              services[services.length - 1].modification = modifications
            }
          }
          if(services.length > 0){
            result[result.length] = list[key];
            result[result.length - 1].services = services;
          }
        }
      }
      return result;
    },
    subcatList(){
      let result = [];
      for (let key in this.serviceList){
        if(+this.serviceList[key].id === +this.newService.category_id){
          for (let keyServ in this.serviceList[key].services){
            if(+this.serviceList[key].services[keyServ].subcategory === 1){
              result.push(this.serviceList[key].services[keyServ]);
            }
          }
        }
      }
      return result;
    },
    validateCategory() {
      let errorCount = 0;
      this.vCategory().result === "error" ? errorCount++ : "";

      return errorCount;
    },
    validateService() {
      let errorCount = 0;
      this.vServiceCat().result === "error" ? errorCount++ : "";
      this.vServiceName().result === "error" ? errorCount++ : "";
      this.vServicePrice().result === "error" ? errorCount++ : "";
      this.vServiceDescription().result === "error" ? errorCount++ : "";

      return errorCount;
    },
    validateSubcategory(){
      let errorCount = 0;
      this.vServiceSubcatCat().result === 'error' ? errorCount++ : "";
      this.vSubcatName().result === 'error' ? errorCount++ : "";

      return errorCount;
    },
    validateEditService() {
      let errorCount = 0;
      this.vEditServiceName().result === "error" ? errorCount++ : "";
      this.vEditServicePrice().result === "error" ? errorCount++ : "";
      this.vEditServiceDescription().result === "error" ? errorCount++ : "";

      return errorCount;
    },
    activeTabIndex() {
      let result = 0;
      this.tabs.forEach(function(item) {
        if (item.isActive) {
          result = item.id;
        }
      });
      return result;
    }
  },
  methods: {
    clickTab(item) {
      for (let key in this.tabs) {
        if (this.tabs[key].id === item.id) {
          this.tabs[key].isActive = true;
        } else {
          this.tabs[key].isActive = false;
        }
      }
    },
    resetSearch(){
      this.searchService = '';
    },
    showEditModifPopup(item){
      this.editServiceItem = item;
      this.editModifPopup.show = true;
    },
    closeEditModifPopup(){
      this.editModifPopup.show = false;
    },
    showEditServicePopup(item){
      this.editServiceItem = item;
      this.editServicePopup.show = true;
    },
    closeEditServicePopup(){
      this.editServicePopup.show = false;
    },
    showEditSubcategoryPopup(item){
      this.editServiceItem = item;
      this.editSubcategoryPopup.show = true;
    },
    closeEditSubcategoryPopup(){
      this.editSubcategoryPopup.show = false;
    },
    showEditCategoryPopup(item){
      this.editCatItem = item;
      this.editCategoryPopup.show = true;
    },
    closeEditCategoryPopup(){
      this.editCategoryPopup.show = false;
    },
    showDeleteSubcategoryPopup(){
      this.deleteSubcategoryPopup.show = true;
    },
    closeDeleteSubcategoryPopup(){
      this.deleteSubcategoryPopup.show = false;
    },
    showNewServicePopup(){
      this.newServicePopup.show = true;
    },
    closeNewServicePopup(){
      this.newServicePopup.show = false;
    },
    showNewSubcatPopup(){
      this.newSubcatPopup.show = true;
    },
    closeNewSubcatPopup(){
      this.newSubcatPopup.show = false;
    },
    showNewCategoryPopup(){
      this.newCategoryPopup.show = true;
    },
    closeNewCategoryPopup(){
      this.newCategoryPopup.show = false;
    },
    vCategory() {
      let validate = validator.validate([
        {
          fieldName: "Категория",
          value: this.category,
          type: "required",
          length: 250
        }
      ]);
      validate.result === "error"
        ? (this.formError.category = validate.message)
        : (this.formError.category = "");
      return validate;
    },
    vServiceCat() {
      let validate = validator.validate([
        {
          fieldName: "Категория",
          value: this.newService.category_id,
          type: "required",
          length: 250
        }
      ]);
      validate.result === "error"
        ? (this.formError.service.category_id = validate.message)
        : (this.formError.service.category_id = "");
      return validate;
    },
    vServiceSubcatCat() {
      let validate = validator.validate([
        {
          fieldName: "Категория",
          value: this.newSubcategory.category_id,
          type: "required",
          length: 250
        }
      ]);
      validate.result === "error"
          ? (this.formError.subcategory.category_id = validate.message)
          : (this.formError.subcategory.category_id = "");
      return validate;
    },
    vSubcatName() {
      let validate = validator.validate([
        {
          fieldName: "Название подкатегории",
          value: this.newSubcategory.name,
          type: "required",
          length: 250
        }
      ]);
      validate.result === "error"
          ? (this.formError.subcategory.name = validate.message)
          : (this.formError.subcategory.name = "");
      return validate;
    },
    vServiceName() {
      let validate = validator.validate([
        {
          fieldName: "Название услуги",
          value: this.newService.name,
          type: "required",
          length: 250
        }
      ]);
      validate.result === "error"
        ? (this.formError.service.name = validate.message)
        : (this.formError.service.name = "");
      return validate;
    },
    vServicePrice() {
      let validate = validator.validate([
        {
          fieldName: "Стоимость услуги",
          value: this.newService.price,
          type: "required",
          length: 250
        },
        {
          fieldName: "Стоимость услуги",
          value: this.newService.price,
          type: "integer"
        }
      ]);
      validate.result === "error"
        ? (this.formError.service.price = validate.message)
        : (this.formError.service.price = "");
      return validate;
    },
    vServiceDescription(){
      let validate = validator.validate([
        {
          fieldName: "Описание услуги",
          value: this.newService.description,
          type: "string",
          length: 595
        },
      ]);
      validate.result === "error"
          ? (this.formError.service.description = validate.message)
          : (this.formError.service.description = "");
      return validate;
    },
    vEditServiceName() {
      let validate = validator.validate([
        {
          fieldName: "Название услуги",
          value: this.editServiceItem.name,
          type: "required",
          length: 250
        }
      ]);
      validate.result === "error"
        ? (this.formError.editService.name = validate.message)
        : (this.formError.editService.name = "");
      return validate;
    },
    vEditServicePrice() {
      let validate = validator.validate([
        {
          fieldName: "Стоимость услуги",
          value: this.editServiceItem.price,
          type: "required",
          length: 250
        },
        {
          fieldName: "Стоимость услуги",
          value: this.editServiceItem.price,
          type: "integer"
        }
      ]);
      validate.result === "error"
        ? (this.formError.editService.price = validate.message)
        : (this.formError.editService.price = "");
      return validate;
    },
    vEditServiceDescription(){
      let validate = validator.validate([
        {
          fieldName: "Описание услуги",
          value: this.editServiceItem.description,
          type: "string",
          length: 595
        },
      ]);
      validate.result === "error"
          ? (this.formError.editService.description = validate.message)
          : (this.formError.editService.description = "");
      return validate;
    },
    closeDeleteServicePopup() {
      this.deleteServicePopup.show = false;
    },
    closeDeleteCategoryPopup() {
      this.deleteCategoryPopup.show = false;
    },
    closeDeleteModificationPopup(){
      this.deleteModificationPopup.show = false;
    },
    addCategory() {
      if (this.validateCategory) {
        return false;
      }
      this.$store.dispatch("startPreloader");

      servicesRepository.addCategory({
        name: this.category
      }).then(resp => {
        this.serviceList = this.filteredGetData(resp.data);
        this.category = "";
        this.$store.dispatch("addNotification", {
          text: "Категория добавлена",
          time: 3,
          color: "success"
        });
        this.closeNewCategoryPopup();
        this.$store.dispatch("stopPreloader");
      }).catch(err => {
        this.$store.dispatch("addNotification", {
          text: err.response.data.message,
          time: 6,
          color: "danger"
        });
        this.$store.dispatch("stopPreloader");
      });
    },
    editCatName() {
      this.$store.dispatch("startPreloader");

      servicesRepository.updateCategory({
        id: this.editCatItem.id,
        name: this.editCatItem.name
      }).then(resp => {
        for (let key in this.serviceList) {
          if (+this.serviceList[key].id === +resp.data.id) {
            this.serviceList[key].editCategory = false;
          }
        }
        this.$store.dispatch("addNotification", {
          text: "Категория успешно изменена",
          time: 3,
          color: "success"
        });
        this.editCatItem = {id: '', name: ''};
        this.closeEditCategoryPopup();
        this.$store.dispatch("stopPreloader");
      }).catch(err => {
        this.$store.dispatch("addNotification", {
          text: err.response.data.message,
          time: 6,
          color: "danger"
        });
        this.$store.dispatch("stopPreloader");
      });
    },
    deleteCategory(id) {
      this.categoryDeleteId = id;
      this.deleteCategoryPopup.show = true;
    },
    deleteCategorySubmit() {
      this.$store.dispatch("startPreloader");

      servicesRepository.deleteCategory({ id: this.categoryDeleteId }).then(resp => {
        this.deleteCategoryPopup.show = false;
        for (let key in this.serviceList) {
          if (+this.serviceList[key].id === +resp.data.id) {
            this.serviceList.splice(key, 1);
          }
        }
        this.$store.dispatch("addNotification", {
          text: "Категория успешно удалена",
          time: 3,
          color: "success"
        });
        this.$store.dispatch("stopPreloader");
      }).catch(err => {
        this.deleteCategoryPopup.show = false;
        this.$store.dispatch("addNotification", {
          text: err.response.data.message,
          time: 6,
          color: "danger"
        });
        this.$store.dispatch("stopPreloader");
      });
    },
    moveUpCategory(id) {
      this.$store.dispatch("startPreloader");

      servicesRepository.moveUpCategory({ id: id }).then(resp => {
        this.serviceList = this.filteredGetData(resp.data);
        this.$store.dispatch("addNotification", {
          text: "Категория успешно перемещена вверх",
          time: 3,
          color: "success"
        });
        this.$store.dispatch("stopPreloader");
      }).catch(err => {
        this.deleteCategoryPopup.show = false;
        this.$store.dispatch("addNotification", {
          text: err.response.data.message,
          time: 6,
          color: "danger"
        });
        this.$store.dispatch("stopPreloader");
      });
    },
    addSubcategory(){
      if(this.validateSubcategory){
        return false;
      }
      this.$store.dispatch("startPreloader");

      let data = {};
      for (let key in this.newSubcategory) {
        data[key] = this.newSubcategory[key];
      }
      servicesRepository.addSubcategory(data).then(resp => {
        this.serviceList = this.filteredGetData(resp.data);
        this.newSubcategory.category_id = "";
        this.newSubcategory.name = "";
        this.$store.dispatch("addNotification", {
          text: "Подкатегория добавлена",
          time: 3,
          color: "success"
        });
        this.closeNewSubcatPopup();
        this.$store.dispatch("stopPreloader");
      }).catch(err => {
        this.$store.dispatch("addNotification", {
          text: err.response.data.message,
          time: 6,
          color: "danger"
        });
        this.$store.dispatch("stopPreloader");
      });
    },
    addService() {
      if (this.validateService) {
        return false;
      }
      this.$store.dispatch("startPreloader");

      let data = {};
      for (let key in this.newService) {
        if(key === 'price'){
          data[key] = this.newService[key].trim();
        }else{
          data[key] = this.newService[key];
        }
      }

      servicesRepository.addService(data).then(resp => {
        this.serviceList = this.filteredGetData(resp.data);
        this.newService.category_id = "";
        this.newService.service_id = "";
        this.newService.name = "";
        this.newService.price = "";
        this.newService.time_hour = 0;
        this.newService.time_minute = 0;
        this.newService.description = "";
        this.newService.hide = 0;
        this.newService.price_from_flag = 0;
        this.newService.is_group = 0;
        this.$store.dispatch("addNotification", {
          text: "Услуга добавлена",
          time: 3,
          color: "success"
        });
        this.closeNewServicePopup();
        this.$store.dispatch("stopPreloader");
      }).catch(err => {
        this.$store.dispatch("addNotification", {
          text: err.response.data.message,
          time: 6,
          color: "danger"
        });
        this.$store.dispatch("stopPreloader");
      });
    },
    editService() {
      if(this.validateEditService){
        return false;
      }
      this.$store.dispatch("startPreloader");
      let data = {};
      for (let key in this.editServiceItem) {
        if (
          key === "id" ||
          key === "name" ||
          key === "price" ||
          key === "time_hour" ||
          key === "time_minute" ||
          key === "description" ||
          key === "hide" ||
          key === 'price_from_flag' ||
          key === 'is_group'
        ) {
          data[key] = this.editServiceItem[key];
        }
      }

      servicesRepository.updateService(data).then(resp => {
        for (let key in this.serviceList) {
          for (let keyS in this.serviceList[key].services) {
            if (+this.serviceList[key].services[keyS].id === +resp.data.id) {
              this.serviceList[key].services[keyS].description =
                  resp.data.description;
              this.serviceList[key].services[keyS].price = resp.data.price;
              this.serviceList[key].services[keyS].time_hour =
                  resp.data.time_hour;
              this.serviceList[key].services[keyS].time_minute =
                  resp.data.time_minute;
            }
          }
        }
        this.$store.dispatch("addNotification", {
          text: "Изменения сохранены",
          time: 3,
          color: "success"
        });
        this.editServiceItem = {
          id: '', name: '', price: 0, time_hour: 0, time_minute: 0, description: 0, hide: 0,
          is_group: 0
        };
        this.closeEditSubcategoryPopup();
        this.closeEditServicePopup();
        this.$store.dispatch("stopPreloader");
      }).catch(err => {
        this.$store.dispatch("addNotification", {
          text: err.response.data.message,
          time: 6,
          color: "danger"
        });
        this.$store.dispatch("stopPreloader");
      });
    },
    deleteService(id) {
      this.serviceDeleteId = id;
      this.deleteServicePopup.show = true;
    },
    deleteSubcategory(id) {
      this.serviceDeleteId = id;
      this.showDeleteSubcategoryPopup();
    },
    deleteServiceSubmit() {
      this.$store.dispatch("startPreloader");

      servicesRepository.deleteService({ id: this.serviceDeleteId }).then(resp => {
        this.deleteServicePopup.show = false;
        this.closeDeleteSubcategoryPopup();
        for (let key in this.serviceList) {
          if (+this.serviceList[key].id === +resp.data.category_id) {
            for (let keyS in this.serviceList[key].services) {
              if (
                  +this.serviceList[key].services[keyS].id === +resp.data.id
              ) {
                this.serviceList[key].services.splice(keyS, 1);
              }
            }
          }
        }
        this.$store.dispatch("addNotification", {
          text: "Успешно удалено",
          time: 3,
          color: "success"
        });
        this.$store.dispatch("stopPreloader");
      }).catch(err => {
        this.deleteServicePopup.show = false;
        this.$store.dispatch("addNotification", {
          text: err.response.data.message,
          time: 6,
          color: "danger"
        });
        this.$store.dispatch("stopPreloader");
      });
    },
    moveUpService(id) {
      this.$store.dispatch("startPreloader");

      servicesRepository.moveUpService({ id: id }).then(resp => {
        this.serviceList = this.filteredGetData(resp.data);
        this.$store.dispatch("addNotification", {
          text: "Услуга успешно перемещена вверх",
          time: 3,
          color: "success"
        });
        this.$store.dispatch("stopPreloader");
      }).catch(err => {
        this.deleteCategoryPopup.show = false;
        this.$store.dispatch("addNotification", {
          text: err.response.data.message,
          time: 6,
          color: "danger"
        });
        this.$store.dispatch("stopPreloader");
      });
    },
    moveUpModification(id) {
      this.$store.dispatch("startPreloader");

      servicesRepository.moveUpModification({ id: id }).then(resp => {
        this.serviceList = this.filteredGetData(resp.data);
        this.$store.dispatch("addNotification", {
          text: "Услуга успешно перемещена вверх",
          time: 3,
          color: "success"
        });
        this.$store.dispatch("stopPreloader");
      }).catch(err => {
        this.deleteCategoryPopup.show = false;
        this.$store.dispatch("addNotification", {
          text: err.response.data.message,
          time: 6,
          color: "danger"
        });
        this.$store.dispatch("stopPreloader");
      });
    },
    deleteModification(id){
      this.modificationDeletedId = id;
      this.deleteModificationPopup.show = true;
    },
    editModification() {
      if(this.validateEditService){
        return false;
      }
      this.$store.dispatch("startPreloader");
      let data = {};
      for (let key in this.editServiceItem) {
        if (
            key === "id" ||
            key === "name" ||
            key === "price" ||
            key === "time_hour" ||
            key === "time_minute" ||
            key === "description" ||
            key === "hide" ||
            key === 'price_from_flag' ||
            key === 'is_group'
        ) {
          data[key] = this.editServiceItem[key];
        }
      }

      servicesRepository.updateModification(data).then(resp => {
        for (let key in this.serviceList) {
          for (let keyS in this.serviceList[key].services) {
            for (let keyM in this.serviceList[key].services[keyS].modification){
              if(+this.serviceList[key].services[keyS].modification[keyM].id === +resp.data.id){
                this.serviceList[key].services[keyS].modification[keyM].name = resp.data.name;
                this.serviceList[key].services[keyS].modification[keyM].description = resp.data.description;
                this.serviceList[key].services[keyS].modification[keyM].price = resp.data.price;
                this.serviceList[key].services[keyS].modification[keyM].time_hour = resp.data.time_hour;
                this.serviceList[key].services[keyS].modification[keyM].time_minute = resp.data.time_minute;
              }
            }
          }
        }
        this.$store.dispatch("addNotification", {
          text: "Изменения сохранены",
          time: 3,
          color: "success"
        });
        this.editServiceItem = {
          id: '', name: '', price: 0, time_hour: 0, time_minute: 0, description: 0,
          hide: 0, price_from_flag: 0, is_group: 0
        };
        this.closeEditModifPopup();
        this.$store.dispatch("stopPreloader");
      }).catch(err => {
        this.$store.dispatch("addNotification", {
          text: err.response.data.message,
          time: 6,
          color: "danger"
        });
        this.$store.dispatch("stopPreloader");
      });
    },
    deleteModificationSubmit() {
      this.$store.dispatch("startPreloader");

      servicesRepository.deleteModification({ id: this.modificationDeletedId }).then(resp => {
        this.deleteModificationPopup.show = false;
        for (let key in this.serviceList) {
          for (let keyS in this.serviceList[key].services) {
            for(let keyM in this.serviceList[key].services[keyS].modification){
              if (+this.serviceList[key].services[keyS].modification[keyM].id === +resp.data.id) {
                this.serviceList[key].services[keyS].modification.splice(keyM, 1);
              }
            }
          }
        }
        this.$store.dispatch("addNotification", {
          text: "Услуга успешно удалена",
          time: 3,
          color: "success"
        });
        this.$store.dispatch("stopPreloader");
      }).catch(err => {
        this.deleteServicePopup.show = false;
        this.$store.dispatch("addNotification", {
          text: err.response.data.message,
          time: 6,
          color: "danger"
        });
        this.$store.dispatch("stopPreloader");
      });
    },
    // Добавляет необходимые для рендерига параметры в полученных от сервера данных
    filteredGetData(data) {
      let newData = data;
      // Исключим из списка удаленные категории и услуги
      let result = newData.reduce((finalList, item) => {
        if(+item.deleted === 0){
          item.services = item.services.filter(serv => {
            return +serv.deleted !== 1;
          });
          finalList.push(item);
        }
        return finalList;
      }, []);
      for (let key in result) {
        if (result[key].services) {
          // Услуги
          for (let keyS in result[key].services) {
            result[key].services[keyS].time_hour = this.getHour(
              result[key].services[keyS].time
            );
            result[key].services[keyS].time_minute = this.getMinute(
              result[key].services[keyS].time
            );
            if(result[key].services[keyS].modification){
              // Модификации
              for (let keyM in result[key].services[keyS].modification) {
                result[key].services[keyS].modification[keyM].time_hour = this.getHour(
                    result[key].services[keyS].modification[keyM].time
                );
                result[key].services[keyS].modification[keyM].time_minute = this.getMinute(
                    result[key].services[keyS].modification[keyM].time
                );
              }
            }
          }
        }
      }
      return result;
    },
    getHour(minutes) {
      return Math.floor(minutes / 60);
    },
    getMinute(minutes) {
      return minutes - Math.floor(minutes / 60) * 60;
    },

  },
  created() {
    this.$store.dispatch("startPreloader");

    servicesRepository.getServices().then(resp => {
      this.serviceList = this.filteredGetData(resp.data);
      servicesRepository.getLimits().then(resp => {
        this.limits = resp.data;
        this.$store.dispatch("stopPreloader");
      }).catch(err => {
        this.$store.dispatch("addNotification", {
          text: err.response.data.message,
          time: 6,
          color: "danger"
        });
        this.$store.dispatch("stopPreloader");
      });
    }).catch(err => {
      this.$store.dispatch("addNotification", {
        text: err.response.data.message,
        time: 6,
        color: "danger"
      });
      this.$store.dispatch("stopPreloader");
    });
  }
};
</script>

<style scoped lang="less">
.services-container{
  word-break: break-all;
  word-wrap: break-word;

  .search{
    width: 100%;
    display: flex;
    flex-wrap: nowrap;
    justify-content: space-between;
    flex-direction: row;

    .field{
      width: 100%;
    }
    .reset{
      text-align: right;
      width: 50px;
    }
  }
  .descr{
    display: flex;
    flex-wrap: nowrap;
    justify-content: flex-start;
    flex-direction: row;
    width: 100%;

    &>div{
      margin-top: 10px;
    }

    &>div:nth-of-type(1){
      span{
        display: inline-block;
        width: 25px;
        height: 14px;
        background-color: #7FA1CA;
        border-radius: 7px;
      }
    }
    &>div:nth-of-type(2){
      margin-left: 20px;
      span{
        display: inline-block;
        width: 25px;
        height: 14px;
        background-color: #F0F4F9;
        border-radius: 7px;
      }
    }
  }

  .service--list-category-item{
    width: 100%;

    .category{
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-start;
      flex-direction: row;
      padding: 7px;
      background-color: #7FA1CA;
      border-radius: 5px;
      box-shadow: 0px 2px 5px 0px rgba(65,162,252,0.25);

      .move-btn{
        width: 50px;
        cursor: pointer;

        .icon{
          color: #fff;
        }
        .text{
          font-size: 8px;
          color: #fff;
        }
      }

      .service--list-cat-name{
        width: calc(100% - 50px);
        font-size: 15px;
        line-height: 26px;
        color: #fff;
      }

      .actions{
        text-align: right;
        margin-top: 10px;
        width: 100%;
      }
    }

    .services{
      .service{
        margin-top: 13px;
        margin-left: 20px;
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-start;
        flex-direction: row;
        padding: 5px;

        &.subcategory{
          background-color: #7FA1CA;
          border-radius: 5px;
          box-shadow: 0px 2px 5px 0px rgba(65,162,252,0.25);

          .move-btn{
            width: 50px;
            cursor: pointer;

            .icon{
              color: #fff;
            }
            .text{
              font-size: 8px;
              color: #fff;
            }
          }

          .service--list-serv-name{
            width: calc(100% - 55px);
            font-size: 15px;
            line-height: 26px;
            color: #fff;
          }
        }
        &:not(.subcategory){
          background-color: #F0F4F9;
          border-radius: 5px;
          box-shadow: 0px 2px 5px 0px rgba(65,162,252,0.25);

          .move-btn{
            width: 50px;
            cursor: pointer;

            .icon{
              color: #80bdff;
            }
            .text{
              font-size: 8px;
            }
          }

          .service--list-serv-name{
            width: calc(100% - 51px);
            font-size: 15px;

            .name{
              line-height: 24px;
            }
            .info{
              font-size: 12px;
              color: gray;
              .price{

              }
              .duration{

              }
            }
          }
        }

        .actions{
          text-align: right;
          margin-top: 10px;
          width: 100%;
        }
      }
    }

    .modifications{
      .modification{
        margin-top: 7px;
        margin-left: 50px;
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-start;
        flex-direction: row;
        padding: 5px;
        background-color: #F0F4F9;
        border-radius: 5px;
        box-shadow: 0px 2px 5px 0px rgba(65,162,252,0.25);


        .move-btn{
          width: 50px;
          cursor: pointer;

          .icon{
            color: #80bdff;
          }
          .text{
            font-size: 8px;
          }
        }

        .service--list-modif-name{
          width: calc(100% - 50px);
          font-size: 15px;

          .name{
            line-height: 24px;
          }
          .info{
            font-size: 12px;
            color: gray;
            .price{

            }
            .duration{

            }
          }
        }

        .actions{
          text-align: right;
          margin-top: 10px;
          width: 100%;
        }
      }
    }
  }
}
.service--container {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  flex-direction: row;

  & > div {
    width: 100%;
  }
}

.service--service-time-inputs {
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  flex-direction: row;

  & > div {
    width: 45%;
  }
}

@media (max-width: 800px) {
  .services-container{
    .descr{
      flex-wrap: wrap;

      &>div{
        width: 100%;
      }

      &>div:nth-of-type(2){
        margin-left: 0;
      }
    }

    .service--list-category-item{

      .category{
        padding: 5px 0;

        .move-btn{
          .text{
            font-size: 7px;
          }
        }

        .service--list-cat-name{
          font-size: 14px;
          line-height: 19px;
        }
      }

      .services{
        .service{
          &.subcategory{
            .move-btn{
              .text{
                font-size: 7px;
              }
            }
            .service--list-serv-name{
              font-size: 14px;
              line-height: 19px;
            }
          }
          &:not(.subcategory){
            .move-btn{
              .text{
                font-size: 7px;
              }
            }

            .service--list-serv-name{
              font-size: 14px;

              .name{
                line-height: 19px;
              }
              .info{
                font-size: 11px;
              }
            }
          }
        }
      }

      .modifications{
        .modification{
          margin-left: 40px;
          .move-btn{
            .text{
              font-size: 7px;
            }
          }

          .service--list-modif-name{
            font-size: 14px;

            .name{
              line-height: 19px;
            }
            .info{
              font-size: 11px;
            }
          }
        }
      }
    }
  }
}
</style>
